// removed by extract-text-webpack-plugin
module.exports = {"Description":"_1MWjd5IwR3WiVQ9SRSloL9","background":"_2tOtsoHoTHWmeoQNLpbCnU","contentWrapper":"_2Rk_KHWh5hh-VE7QtrEHcm","heading":"_2zfqToexBgOaWQMjoIQsMJ","underlining":"_1JZihwY5K4vgx9H-oSzJmw","text":"_3BOZWAqFq0llin_uzsNJHb","color-white":"_3WltDOdCRLVnNTgCC8kW8Q","color-dark":"_2WOo6f6FGuyFqTFcPW-Yov","underlining-blue":"_3cSIo6wiyKcBLR6w-jM9EJ","underlining-yellow":"_1EbKclw3AzOi6Qe9ROjLyp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Description/Description.stylesheet.css
// module id = 228
// module chunks = 0